import { generatePath } from 'react-router';
import { DRIVE_PAGE } from '@/common/constants/pages';
export function toTreeItem(item) {
    return {
        id: item.id,
        title: item.title,
        type: 'appSection',
        children: item.children?.map(toTreeItem) ?? [],
        collapsed: item.collapsed ?? true,
        icon: item.icon,
        url: item.url ?? generatePath(DRIVE_PAGE, { section: item.id }),
        iconClassName: item.iconClassName,
        isSubSection: !!item.isSubSection,
        isSectionEndAbove: !!item.isSectionEndAbove,
    };
}
